import { Controller } from "@hotwired/stimulus"
// @ts-expect-error Lexxy does not have types
import { highlightCode } from "@37signals/lexxy"

export default class SyntaxHighlightController extends Controller {
  connect() {
    highlightCode()
  }
}
